module.exports = __webpack_public_path__ + "img/oaknest-7.ac2b1dda.jpeg";